// @flow

/**
 * Module dependencies.
 */

import { compose } from 'recompose';
import { translator } from 'core/utils';
import Features from 'client/components/home/features';
import Header from 'client/components/home/header';
import MoneyTransfer from 'client/components/home/money-transfer';
import PageContent from 'client/components/core/page-content';
import React, { Component } from 'react';
import StickyNavbarTrigger from 'client/components/core/sticky-navbar/sticky-navbar-trigger';
import Transferring from 'client/components/transferring';
import entities from 'client/core/entities';
import zendeskEntities from 'client/core/entities/zendesk';

/**
 * `Props` type.
 */

type Props = {
  translate: Function
};

/**
 * Export `Home`.
 */

class Home extends Component {

  /**
   * Props.
   */

  props: Props;

  /**
   * Render.
   */

  render(): React$Element<*> {
    const { translate } = this.props;
    const {
      homeCta,
      homeFeatures,
      homeMoneyTransferGlobal,
      homeMoneyTransferSecurity
    } = entities(translate);

    const { mailSubjects } = zendeskEntities(translate);

    return (
      <PageContent>
        <Header
          formTransferRequestSubject={mailSubjects.transferRequest}
          lead={translate('homepage.header.lead')}
          title={translate('homepage.header.title')}
        />

        <Features features={homeFeatures} />

        <StickyNavbarTrigger>
          <MoneyTransfer
            cta={homeCta}
            leftItem={homeMoneyTransferGlobal}
            rightItem={homeMoneyTransferSecurity}
          />

          <Transferring
            formTransferRequestSubject={mailSubjects.transferRequest}
          />
        </StickyNavbarTrigger>
      </PageContent>
    );
  }

}

export default compose(
  translator()
)(Home);



// WEBPACK FOOTER //
// ../src/client/containers/home/index.js